import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import moment from 'moment';
import { Row, Col, Divider, Collapse, Typography, Popover } from 'antd';
import { VideoCameraOutlined, CalendarOutlined, InfoCircleTwoTone } from '@ant-design/icons';
import AppointmentHeader from '../../../components/mobile/appointment/AppointmentHeader';
import { ReactComponent as CalendarSvg } from '../../../assets/icons/appointment/calendar.svg';
import { ReactComponent as BookSvg } from '../../../assets/icons/appointment/book.svg';
import { ReactComponent as ExclamationCircleSvg } from '../../../assets/icons/appointment/exclamation-circle.svg';
import { getAppointmentDetailAPICall } from '../../../api/appointment';

const styles = {
  box: {
    borderTop: '1px solid #EAEAEA',
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 20,
    paddingRight: 20,
  },
  label: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "20px",
    display: "flex",
    alignItems: "center",
    color: "#262626",
    margin: 0,
    marginRight: 10
  },
  text: {
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "20px",
    color: "#262626",
    margin: 0,
    marginRight: 10
  },
  doctor: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "20px",
    display: "flex",
    alignItems: "center",
    color: "#15A9E1"
  },
  panel: {
    border: 0
  }
}

const { Panel } = Collapse;
const { Title, Paragraph } = Typography;

function MobileAppointmentDetailScreen() {
  const { t } = useTranslation(['appointment', 'common']);
  const { id } = useParams();
  const [appointment, setAppointment] = useState(null);

  console.log("id", id)

  const fetchDetailAppointment = async () => {
    const { responseStatus, responseJSON } = await getAppointmentDetailAPICall(id)
    if (responseStatus >= 200 && responseStatus < 300) {
      setAppointment(responseJSON.data)
    } else {
      console.log(responseStatus)
    }
  }

  useEffect(() => {
    fetchDetailAppointment();
  }, []);

  const data = [
    {
      title: t('appointment:overview.presentingComplaint'),
      description: 'testing',
      popup: ''
    },
    {
      title: t('appointment:overview.historyPresenting'),
      description: 'testing',
      popup: 'Autopopulated text from answers to triage questions at booking.'
    },
    {
      title: t('appointment:overview.pastMedical'),
      description: 'testing',
      popup: ''
    },
    {
      title: t('appointment:overview.medication'),
      description: 'testing',
      popup: ''
    },
    {
      title: t('appointment:overview.medication'),
      description: 'testing',
      popup: ''
    },
    {
      title: t('appointment:overview.suspects'),
      description: 'testing',
      popup: ''
    },
    {
      title: t('appointment:overview.recomendedAction'),
      description: 'testing',
      popup: ''
    }
  ];

  console.log(appointment)

  const popOver = (text) => {
    const content = (
      <Row align="middle" justify="center">
        <ExclamationCircleSvg style={{ marginRight: 10}} />
        <Title level={4} style={styles.label}>
          {text}
        </Title>
      </Row>
    )

    if (text !== "") {
      return (
        <Popover placement="topRight" content={content}>
          <InfoCircleTwoTone />
        </Popover>
      )
    }

    return <></>;
  }

  return (
    <>
      <Box paddingX={20}>
        <AppointmentHeader
          icon={<CalendarSvg />}
          title={t('appointment:overview.overview')}
        />
      </Box>
      <Box style={styles.box}>
        <Row>
          <Col xs={10}>
            <Title level={4} style={styles.label}>
              {t('appointment:overview.appointmentFor')}
            </Title>
          </Col>
          <Col xs={14}>
            <Title level={4} style={styles.text}>
              {appointment?.appointment_for ?? '-'}
            </Title>
          </Col>
        </Row>
      </Box>
      <Box style={styles.box}>
        <Row>
          <Col xs={10}>
            <Title level={4} style={styles.label}>
              {t('appointment:overview.doctorName')}
            </Title>
          </Col>
          <Col xs={14}>
            <Title level={4} style={styles.doctor}>
            {appointment?.doctor_name ?? 'Not Set'}
            </Title>
          </Col>
        </Row>
      </Box>
      <Box style={styles.box}>
        <Row>
          <Col xs={10}>
            <Title level={4} style={styles.label}>
              {t('appointment:overview.appointmentType')}
            </Title>
          </Col>
          <Col xs={14}>
            <Row align="middle" justify="start">
              <VideoCameraOutlined style={{ marginRight: 10}} />
              <Title level={4} style={styles.text}>
                {appointment?.appointment_type ?? 'Video'}
              </Title>
            </Row>
          </Col>
        </Row>
      </Box>
      <Box style={styles.box}>
        <Row>
          <Col xs={10}>
            <Title level={4} style={styles.label}>
              {t('appointment:overview.dateTime')}
            </Title>
          </Col>
          <Col xs={14}>
            <Row align="left" justify="start">
              <CalendarOutlined style={{ marginRight: 10}} />
              <Title level={4} style={styles.text}>
                {moment(appointment?.appointment_date).format('ddd DD MMMM YYYY, hh:mm a')}
              </Title>
            </Row>
          </Col>
        </Row>
      </Box>
      <Box style={styles.box}>
        <Row>
          <Col xs={10}>
            <Title level={4} style={styles.label}>
              {t('appointment:overview.healthConcern')}
            </Title>
          </Col>
          <Col xs={14}>
            <Title level={4} style={styles.text}>
              {appointment?.health_consern}
            </Title>
          </Col>
        </Row>
      </Box>
      <Box style={styles.box}>
        <Row>
          <Col xs={10}>
            <Title level={4} style={styles.label}>
              {t('appointment:overview.yourSymptoms')}
            </Title>
          </Col>
          <Col xs={14}>
            <Paragraph>
              {appointment?.your_symptoms}
            </Paragraph>
          </Col>
        </Row>
      </Box>
      <Box paddingX={20} marginBottom={50}>
        <Divider />
        <Box marginBottom={34}>
          <AppointmentHeader
            icon={<BookSvg />}
            title={t('appointment:overview.notes')}
          />
        </Box>
        <Box marginTop={60}>
          {data.map(({title, description, popup}, key) => (
            <Collapse
              key={key}
              expandIconPosition="left"
              bordered={false}
              className="appointment-notes"
            >
              <Panel header={title} extra={popOver(popup)} style={styles.panel}>
                {description}
              </Panel>
            </Collapse>
          ))}
        </Box>
      </Box>
    </>
  );
}

export default MobileAppointmentDetailScreen;
